import { fetchApi } from '../apiService';

export const userLogin = async (loginDetails,apiToken) => {
    const response = await fetchApi('common/userAuth',loginDetails,apiToken);
    return response;
}

export const userTokenAuthenticate = async (userTokenAuth) => {
    const response = await fetchApi('common/userTokenAuth',{},userTokenAuth);
    return response;
}

export const userLogout = async (userTokenAuth) => {
    const response = await fetchApi('common/userLogout',{},userTokenAuth);
    return response;
}

export const sendOtp = async (mobileNoDetails,apiToken) => {
    const response = await fetchApi('common/sendOtp',mobileNoDetails,apiToken);
    return response;
}

export const validateOtp = async (otpDetails,apiToken) => {
    const response = await fetchApi('common/validateOtp',otpDetails,apiToken);
    return response;
}

export const getUsersForMobileNo = async (filters,apiToken) => {
    const response = await fetchApi('common/getUsersForMobileNo',filters,apiToken);
    return response;
}

export const updateUsersPasswordForMobileNo = async (passwordDetails,apiToken) => {
    const response = await fetchApi('common/updateUsersPasswordForMobileNo',passwordDetails,apiToken);
    return response;
}